module.exports = __webpack_public_path__ + "img/weitu.62096deb.png";